import { Accordion, Box, Flex } from "@qws-org/ui-kit";
import type { FC } from "react";
import { useEffect } from "react";

import { MobileMenuButton } from "~/features/headerV3/components/MobileMenuButton";

import type { HeaderProps } from "../HeaderV3";
import { LocaleSelect } from "./LocaleSelect";
import { NavbarItemMobile } from "./NavbarItemMobile";

type MobileMenuListProps = HeaderProps & {
  closeBurgerMenu: () => void;
  isBurgerMenuOpen: boolean;
};

export const MobileMenuList: FC<MobileMenuListProps> = (props) => {
  const {
    clickHeaderSub,
    clickHeaderMain,
    getUrl,
    onCallAction,
    isActionInactive,
    closeBurgerMenu,
    data,
    isBurgerMenuOpen,
  } = props;

  useEffect(() => {
    if (isBurgerMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [isBurgerMenuOpen]);

  return (
    <Flex
      align="center"
      display={isBurgerMenuOpen ? "flex" : "hidden"}
      d={{
        display: "hidden",
        flexDirection: "column",
      }}
      flexDirection={"column"}
      p={{ px: 24, py: 16 }}
      bg="background-primary"
      md={{ position: { top: 76 } }}
      position={{
        type: "fixed",
        top: 52,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 40,
      }}
      className={`overflow-scroll lg:overflow-auto`}
      data-testid="header-mobile-menu"
    >
      {data.mobile_burger_menu?.action_items && (
        <Accordion allowsMultipleExpanded={true}>
          {data.mobile_burger_menu.action_items
            ?.filter((action) => {
              if (action?.menu_action_items_id?.action) {
                return !isActionInactive(action.menu_action_items_id.action);
              }

              return true;
            })
            ?.map(
              (item, idx) =>
                item?.menu_action_items_id && (
                  <NavbarItemMobile
                    key={item.menu_action_items_id.id}
                    {...item.menu_action_items_id}
                    closeBurgerMenu={closeBurgerMenu}
                    clickHeaderMain={clickHeaderMain}
                    clickHeaderSub={clickHeaderSub}
                    getUrl={getUrl}
                    onCallAction={onCallAction}
                    dataTestId={`header-mobile-menu-item-${idx}`}
                  />
                ),
            )}
        </Accordion>
      )}

      {data?.languages && (
        <Box
          m={{ my: 8 }}
          width="100%"
          display="block"
          md={{ display: "hidden", p: { px: 15 } }}
          p={{ px: 15 }}
        >
          <LocaleSelect
            {...data}
            languages={data.languages}
            isNonModal={false}
            variant="static"
          />
        </Box>
      )}

      {data?.top_additional_menu?.action_items
        ?.filter((action) => {
          if (action?.menu_action_items_id?.action) {
            return !isActionInactive(action.menu_action_items_id.action);
          }

          return true;
        })
        ?.map((item, idx) => (
          <MobileMenuButton
            key={item?.id}
            size="small"
            weight="bold"
            item={item?.menu_action_items_id}
            getUrl={getUrl}
            onCallAction={onCallAction}
            variant="transparent"
            dataTestId={`header-mobile-menu-button-${idx}`}
          />
        ))}
    </Flex>
  );
};
